module.exports = __webpack_public_path__ + "static/media/BigruixianBlackGB.a63aaf00.TTF";